// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__16huM","tab":"Tabs_tab__3s4mG","tabActive":"Tabs_tabActive___3lkL"};